export default {
  pageTitle: 'Compliance & Quality Assurance',
  cards: [
    {
      title: 'Details',
      fields: [
        {
          label:
            'Do you have internal company policy on FCPA (Foreign Corrupt Practice Act), bribery and gifting?',
          name: 'internalCompanyPolicy',
          type: 'yes_no',
          required: true,
        },
        {
          label:
            'Are any key employees or senior management members of your organization a government or public official?',
          name: 'keyEmployees',
          type: 'yes_no',
          required: true,
        },
        {
          label:
            'Are you or any of your related entities owned or partially owned by foreign governments?',
          name: 'ownedByForeignGovernments',
          type: 'yes_no',
          required: true,
        },
        {
          label:
            'Do you have a passed Independent 3rd Party Factory Compliance Audit report (BV, Intertek, Fiti, SGS, Wrap Approval) that is valid within the last 6-12 months?',
          name: 'passedIndependent3rdParty',
          type: 'yes_no',
          required: true,
        },
        {
          cond: ({ passedIndependent3rdParty }) =>
            passedIndependent3rdParty === 'yes',
          label: 'Please provide a copy',
          name: 'passedIndependent3rdPartyCopy',
          type: 'file',
          required: true,
        },
        {
          label: 'Do you have a 3rd party social compliance audit?',
          name: 'thirdPartySocialComplianceAudit',
          type: 'yes_no',
          required: true,
        },
        {
          cond: ({ thirdPartySocialComplianceAudit }) =>
            thirdPartySocialComplianceAudit === 'yes',
          label: 'Please provide a copy',
          name: 'thirdPartySocialComplianceAuditCopy',
          type: 'file',
          required: true,
        },
        {
          label: 'What are your Quality Assurance process for Fabric Audits?',
          name: 'qualityAssuranceProcessFabricAudits',
          type: 'text',
          required: true,
        },
        {
          label:
            'What are your Quality Assurance process for In-line Inspection AQL?',
          name: 'qualityAssuranceProcessForInLineInspectionAql',
          type: 'text',
          required: true,
        },
        {
          label:
            'What are your Quality Assurance process for Final Inspection Audit AQL?',
          name: 'qualityAssuranceProcessForFinalInspectionAuditAql',
          type: 'text',
          required: true,
        },
      ],
    },
  ],
};
